import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import "../style/glasscleaning.css";
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-glass1.png";
import imgServ2 from "../images/photo-glass2.png";
import imgServ3 from "../images/photo-glass3.png";
import imgServ4 from "../images/photo-glass4.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Glasscleaning() {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="continer-office-cleaning">
      <div className="cover-img-content-glass">
        <div className="photocontent-box">
          <Typography
            variant="h3"
            sx={{
              color: "var(--mainColor)",
              fontFamily: "var(--fontFamily)",
              fontWeight: "medium",
            }}
          >
            Glas und Fensterreinigung
          </Typography>
        </div>
      </div>
      <div className="content-text-for-services">
        <div className="text-service-first">
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              color: "var(--mainColorLight)",
              fontFamily: "var(--fontFamily)",
              fontWeight: "700",
            }}
          >
            Exzellente Glasreinigung für einen makellosen Eindruck
          </Typography>
        </div>
        <div
          className="text-body-service"
          data-aos="zoom-out"
          data-aos-anchor-placement="top-bottom"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <Typography
            gutterBottom
            variant="body2"
            sx={{
              fontWeight: "normal",
              fontFamily: "var(--fontFamily)",
              color: "var(--textColor)",
            }}
          >
            Saubere Glasflächen stehen für Stil, Professionalität und
            Werterhalt. Unser Glasreinigungsservice bietet Ihnen erstklassige
            Reinigungslösungen für Fenster, <br />
            Glasfassaden, Glastüren, Schaufenster,Wintergärten und weitere
            Glasflächen – im privaten wie auch im gewerblichen Bereich.
            <br />
            Unsere erfahrenen Reinigungsteams arbeiten mit modernster Technik
            und hochwertigen, umweltfreundlichen Reinigungsmitteln. So
            garantieren wir streifenfreie,
            <br /> glänzende Ergebnisse bis ins kleinste Detail. Ob regelmäßige
            Pflege oder individuelle Sonderreinigung – wir passen unseren
            Service flexibel an Ihre Anforderungen an.
            <br />
            Verlassen Sie sich auf Präzision, Zuverlässigkeit und höchste
            Qualität für Glasflächen, die Eindruck hinterlassen.
          </Typography>
        </div>
        <div className="textandphoto-service">
          <div
            className="text-service-line"
            data-aos="fade-right"
            data-aos-offset="50"
            data-aos-duration="1000"
            style={{ display:"block",
            }}
          >
            <h1 style={{ marginBottom: "16px",}}>Ihre Vorteile auf einen Blick:</h1>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                marginBottom: "16px",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Professionelle Glasreinigung für alle Arten von Glasflächen
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                 marginBottom: "16px",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Gründliche Entfernung von Schmutz, Staub und Rückständen
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                 marginBottom: "16px",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Streifenfreie, brillante Ergebnisse
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                marginBottom: "16px",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Pünktlicher und diskreter Service
            </Typography>
            
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                marginBottom: "16px",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Transparente Pre
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
                marginBottom: "16px",
              }}
            ></Typography>
          </div>
          <div className="photo-service-line">
            <div
              className="photo1-service"
              data-aos="flip-left"
              data-aos-offset="50"
              data-aos-duration="1000"
            >
              <LazyLoadImage
                src={imgServ1}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
              />
            </div>
            <div
              className="photo2-service"
              data-aos="flip-right"
              data-aos-offset="50"
              data-aos-duration="1000"
            >
              <LazyLoadImage
                src={imgServ2}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="content-text-for-services2">
        <div className="text-service-first">
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              color: "var(--mainColorLight)",
              fontFamily: "var(--fontFamily)",
              fontWeight: "700",
            }}
          >
            Entdecken Sie die Vorteile unserer Glasreinigungsdienste!
          </Typography>
        </div>
        <div className="text-body-service2">
          <div
            className="text-for-service-body"
            data-aos="fade-right"
            data-aos-anchor-placement="top-bottom"
            data-aos-offest="200"
            data-aos-duration="1000"
          >
            <Typography
              gutterBottom
              variant="body2"
              sx={{
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
              }}
            >
              Bei unserer Glasreinigung steht Qualität an erster Stelle. Wir
              verstehen, dass saubere Glasflächen nicht nur das Licht
              hereinlassen, sondern auch einen positiven Eindruck hinterlassen.
              Deshalb bieten wir maßgeschneiderte Reinigungslösungen für eine
              Vielzahl von Glasoberflächen an, darunter Fenster, Glaswände,
              Schaufenster, Glasdächer und mehr.
              <br />
              Unsere erfahrenen Reinigungsteams verwenden moderne Techniken und
              umweltfreundliche Reinigungsmittel, um hartnäckigen Schmutz,
              Fingerabdrücke und Streifen zu entfernen. Egal, ob es sich um eine
              Einzelreinigung oder einen regelmäßigen Reinigungsservice handelt,
              wir sind flexibel und passen uns Ihren Anforderungen an.
            </Typography>
          </div>
        </div>
        <div className="textandphoto-service2">
          <div
            className="text-service-line2"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
          >
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "var(--fontFamily)",
                color: "var(--textColor)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Professionelle Reinigung für alle Arten von Glasflächen
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Gründliche Entfernung von Schmutz, Staub und Rückständen
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Streifenfreie und glänzende Ergebnisse
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Pünktliche und zuverlässige Dienstleistungen
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Wettbewerbsfähige Preise und transparente Abrechnung
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Hochbewertete Reinigung.
            </Typography>
            <Typography
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: "var(--textColor)",
                fontFamily: "var(--fontFamily)",
              }}
            >
              <FaRegCheckCircle
                className="checkicon"
                style={{ marginRight: "10px" }}
              />{" "}
              Wohnungsreinigungsdienst in der Nähe von Städten
            </Typography>
          </div>
          <div className="photo-service-line2">
            <div
              className="photo3-service"
              data-aos="flip-left"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <LazyLoadImage
                src={imgServ4}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
              />
            </div>
            <div
              className="photo4-service"
              data-aos="flip-right"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <LazyLoadImage
                src={imgServ3}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Infokontakt />
      <Footer />
    </div>
  );
}

export default Glasscleaning;
